/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
export default {

    
    async uploadVideo(blob, cb, uploadProgress) {
        let Vimeo = require('vimeo').Vimeo;

        var CLIENT_ID = "e497d8839f1f561852c70ca7b51f5d839e2881ca"
        var CLIENT_SECRET = "ba2YlmG+LF+AhMleWvRrvKcdZaFUSCsUEaatyX+oihMJG8BzHgxCU12VaJJ5Rv5K3n+rRHx2mjuiniG3WnqBuH+fQDIXfRMqhrkHx/k5wt2yjJVec5YhQDmVfA7y1hc2"
        var ACCESS_TOKEN = "76e93d83d363519cf021fd32f8fda8d8"
        var client = new Vimeo(CLIENT_ID, CLIENT_SECRET, ACCESS_TOKEN);
        
        await client.upload(
            blob,

            function (uri) {
                console.log('Upload Completo. URL:', uri)
                cb(uri)
            },
            function (bytesUploaded, bytesTotal) {
                var percentage = (bytesUploaded / bytesTotal * 100).toFixed(2)
                console.log(bytesUploaded, bytesTotal, percentage + '%')
                uploadProgress(percentage)
            },
            function (error) {
                console.log('Uploadl Falhou, erro: ' + error)
            }
        )
    },
}